module.exports = "## Create better compositions\r\n\r\nImageResize.org’s online photo cropper lets you crop your images to fit the perfect composition and get rid of unwanted areas from your photo. \r\n\r\nSometimes it is important to capture the moment than to worry about composition. The photographic moments happens so fast and you probably don’t have time to decide what to include in the frame. Need not worry, our photo cropper lets you crop your images using a specific aspect ratio, exact dimensions, or simply drag and crop. "


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/CropImages/crop-images-section-one.md
// module id = 1152
// module chunks = 0